var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "72.611099mm",
    viewBox: "0 0 132.29167 72.611099",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-224.3889)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117",
    transform: "matrix(0.74080592,0,0,0.74080592,2.3541594e-7,76.980642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.104245,272.34558 C 27.179998,270.78213 24.534157,269.82 21.407255,269.82 9.5009732,269.82 9.0826126e-7,278.59938 9.0826126e-7,287.98009 9.0826126e-7,293.63257 4.5700889,297 10.463097,297 c 9.621238,0 21.407254,-9.01991 21.52752,-18.03982 v -79.97654 h -2.886372 z",
    id: "path27",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.428469,198.98364 H 31.47573 v 12.02655 h 32.952739 z",
    id: "path29",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.89103,198.98364 v 12.02655 h 30.066368 v 61.21512 c -1.924247,-1.56345 -4.570088,-2.52557 -7.69699,-2.52557 -11.906282,0 -21.407254,8.77938 -21.407254,18.16008 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.407254,-8.89964 21.52752,-18.03982 v -79.85627 z",
    id: "path31",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.6241,230.73366 c 0,-3.4877 -2.88637,-6.37407 -6.37407,-6.37407 -3.60797,0 -6.49434,2.88637 -6.49434,6.37407 0,2.04451 1.20266,3.8485 2.64584,4.93088 0.84186,0.60133 1.68372,1.08239 2.64584,1.32292 0.7216,0.12027 1.68372,0.3608 2.52558,0.3608 1.32292,0 2.64584,-0.3608 3.72823,-0.72159 1.32292,-0.3608 2.16478,-0.72159 3.4877,-1.44319 0.12026,-0.12026 0.36079,-0.12026 0.48106,-0.12026 0.36079,0 0.48106,0.48106 0.48106,0.96212 0,0.24053 0,0.60133 -0.12027,0.96212 -0.24053,1.44319 -7.21592,20.68567 -8.89964,26.93947 0,1.20266 2.16478,1.32292 2.76611,1.32292 1.08238,0 2.40531,-0.24053 3.36743,-0.96212 0.24053,-0.24053 9.7415,-34.03513 9.7415,-34.03513 0.3608,-1.68372 0.84186,-3.24717 0.96213,-3.72823 0,-0.96212 -0.96213,-1.44319 -1.20266,-1.56345 -0.24053,0 -0.48106,0 -1.08239,0.48106 -0.60133,0.48106 -5.41194,6.2538 -8.65911,6.2538 z",
    id: "path33",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.68036258,16.92532)",
    id: "g241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 151.92144,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 165.58992,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 179.2584,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxeer);
export default __webpack_public_path__ + "static/media/cxeer.c887b59e0dd0d2776189bd120ba0ebb5.svg";
export { ForwardRef as ReactComponent };